/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum BoatType {
    SegelbootSegelyacht = 'SegelbootSegelyacht',
    MotorbootMotoryacht = 'MotorbootMotoryacht',
    Trimaran = 'Trimaran',
    Katamaran = 'Katamaran',
    Zille = 'Zille',
    Jetski = 'Jetski',
    Schnellboote = 'Schnellboote',
    Klassikboot = 'Klassikboot',
    SchlauchbootOhneFestrumpf = 'SchlauchbootOhneFestrumpf',
    Windsurfbretter = 'Windsurfbretter',
    Ruderboote = 'Ruderboote',
    Tretboote = 'Tretboote',
    Kajaks = 'Kajaks',
    Kanus = 'Kanus',
    Eigenbaufahrzeuge = 'Eigenbaufahrzeuge',
    Beiboot = 'Beiboot'
  }

    export const BoatTypeTranslocoMap: Record<BoatType, string> = {
    [BoatType.SegelbootSegelyacht]: 'boatType.segelbootSegelyacht',
    [BoatType.MotorbootMotoryacht]: 'boatType.motorbootMotoryacht',
    [BoatType.Trimaran]: 'boatType.trimaran',
    [BoatType.Katamaran]: 'boatType.katamaran',
    [BoatType.Zille]: 'boatType.zille',
    [BoatType.Jetski]: 'boatType.jetski',
    [BoatType.Schnellboote]: 'boatType.schnellboote',
    [BoatType.Klassikboot]: 'boatType.klassikboot',
    [BoatType.SchlauchbootOhneFestrumpf]: 'boatType.schlauchbootOhneFestrumpf',
    [BoatType.Windsurfbretter]: 'boatType.windsurfbretter',
    [BoatType.Ruderboote]: 'boatType.ruderboote',
    [BoatType.Tretboote]: 'boatType.tretboote',
    [BoatType.Kajaks]: 'boatType.kajaks',
    [BoatType.Kanus]: 'boatType.kanus',
    [BoatType.Eigenbaufahrzeuge]: 'boatType.eigenbaufahrzeuge',
    [BoatType.Beiboot]: 'boatType.beiboot',
    };

    export const BoatTypeOptions = [
  { value: BoatType.SegelbootSegelyacht, labelKey: 'boatType.segelbootSegelyacht' },
  { value: BoatType.MotorbootMotoryacht, labelKey: 'boatType.motorbootMotoryacht' },
  { value: BoatType.Trimaran, labelKey: 'boatType.trimaran' },
  { value: BoatType.Katamaran, labelKey: 'boatType.katamaran' },
  { value: BoatType.Zille, labelKey: 'boatType.zille' },
  { value: BoatType.Jetski, labelKey: 'boatType.jetski' },
  { value: BoatType.Schnellboote, labelKey: 'boatType.schnellboote' },
  { value: BoatType.Klassikboot, labelKey: 'boatType.klassikboot' },
  { value: BoatType.SchlauchbootOhneFestrumpf, labelKey: 'boatType.schlauchbootOhneFestrumpf' },
  { value: BoatType.Windsurfbretter, labelKey: 'boatType.windsurfbretter' },
  { value: BoatType.Ruderboote, labelKey: 'boatType.ruderboote' },
  { value: BoatType.Tretboote, labelKey: 'boatType.tretboote' },
  { value: BoatType.Kajaks, labelKey: 'boatType.kajaks' },
  { value: BoatType.Kanus, labelKey: 'boatType.kanus' },
  { value: BoatType.Eigenbaufahrzeuge, labelKey: 'boatType.eigenbaufahrzeuge' },
  { value: BoatType.Beiboot, labelKey: 'boatType.beiboot' },
    ];

